<template>
    <div>
        <div class="card-body text-center">
            <button type="button" class="btn btn-info" @click="shipTrade()">Ship</button>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                After the merchandise if loaded and handed off to the shipper, please click on Ship button. The buyer will release the payment soon after.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Ship",
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {
            }
        },
        beforeMount() {
        },
        methods: {
            async shipTrade() {
                try{
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/ship', { comments: '' });
                    this.events.$emit('trade:reload');
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Shipment status updates successfully', 'Success');
                }catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Shipment failed', 'Failure');
                }
            }
        }
    }
</script>

<style scoped>

</style>
